import React, { useState } from "react";
import { Form } from "react-bootstrap";

const CustomCheckbox = ({ handleChange, name, label, val }) => {
  const [checked, setChecked] = useState(false);

  return (
    <div className="box">
      <input
        type="checkbox"
        onChange={handleChange}
        value={val}
        name={name}
        id=""
      />
      <div className="boxContent">
        <p>{label}</p>
      </div>
    </div>
  );
};
export default CustomCheckbox;
